let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7xpt2")).then(() => parcelRequire('8l3CP'));